import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const INITIAL_POSITIONS = [
  { id: 1, title: 'Executive Personal Assistant to the CEO', department: 'Administration', type: 'Full-time', location: 'Accra, Ghana', status: 'Active', salary: '5,000 - 8,000' },
  { id: 2, title: 'Senior Software Engineer', department: 'Engineering', type: 'Full-time', location: 'Remote', status: 'Draft', salary: '12,000 - 18,000' },
];

const Positions = () => {
  const [positions, setPositions] = useState(INITIAL_POSITIONS);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPosition, setCurrentPosition] = useState({
    title: '', department: 'Administration', type: 'Full-time', location: 'Accra, Ghana', status: 'Active', salary: ''
  });

  const handleSave = (e) => {
    e.preventDefault();
    if (isEditing) {
      setPositions(positions.map(p => p.id === currentPosition.id ? currentPosition : p));
    } else {
      setPositions([...positions, { ...currentPosition, id: Date.now() }]);
    }
    resetForm();
  };

  const resetForm = () => {
    setIsEditing(false);
    setCurrentPosition({ title: '', department: 'Administration', type: 'Full-time', location: 'Accra, Ghana', status: 'Active', salary: '' });
  };

  const editPosition = (pos) => {
    setIsEditing(true);
    setCurrentPosition(pos);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const deletePosition = (id) => {
    if (window.confirm('Are you sure you want to delete this position?')) {
      setPositions(positions.filter(p => p.id !== id));
    }
  };

  const inputStyle = "w-full px-4 h-12 rounded-[4px] border border-gray-200 focus:border-brand-secondary focus:ring-1 focus:ring-brand-secondary/20 outline-none bg-white text-sm";
  const selectStyle = `${inputStyle} appearance-none bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236b7280%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')] bg-[length:12px_12px] bg-[right_16px_center] bg-no-repeat pr-10`;

  return (
    <div className="space-y-6 max-w-7xl">
      <div className="card p-6 sm:p-8 border border-gray-100 shadow-sm">
        <h2 className="text-xl font-bold text-[#11469A] mb-8 flex items-center justify-between border-b border-gray-50 pb-4">
          <div className="flex items-center gap-2">
            <SafeIcon name={isEditing ? "Edit3" : "Plus"} size={24} />
            {isEditing ? 'Edit Position' : 'Create New Position'}
          </div>
          {isEditing && (
            <button onClick={resetForm} className="text-xs font-bold text-gray-400 uppercase tracking-widest hover:text-red-500">Cancel</button>
          )}
        </h2>
        <form onSubmit={handleSave} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Job Title</label>
              <input 
                type="text" 
                required
                value={currentPosition.title}
                onChange={(e) => setCurrentPosition({...currentPosition, title: e.target.value})}
                placeholder="e.g. Senior Project Manager" 
                className={inputStyle} 
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Department</label>
              <select 
                className={selectStyle}
                value={currentPosition.department}
                onChange={(e) => setCurrentPosition({...currentPosition, department: e.target.value})}
              >
                <option>Administration</option>
                <option>Engineering</option>
                <option>Marketing</option>
                <option>Operations</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Location</label>
              <input type="text" value={currentPosition.location} onChange={(e) => setCurrentPosition({...currentPosition, location: e.target.value})} placeholder="City, Country" className={inputStyle} />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Job Type</label>
              <select className={selectStyle} value={currentPosition.type} onChange={(e) => setCurrentPosition({...currentPosition, type: e.target.value})}>
                <option>Full-time</option>
                <option>Part-time</option>
                <option>Contract</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Status</label>
              <select className={selectStyle} value={currentPosition.status} onChange={(e) => setCurrentPosition({...currentPosition, status: e.target.value})}>
                <option>Active</option>
                <option>Draft</option>
                <option>Closed</option>
              </select>
            </div>
          </div>
          <div className="flex justify-start">
            <button type="submit" className="bg-[#11469A] hover:bg-[#0d3678] text-white px-10 h-12 rounded-[4px] font-bold shadow-md transition-all text-sm uppercase tracking-wider">
              {isEditing ? 'Update Position' : 'Create Position'}
            </button>
          </div>
        </form>
      </div>

      <div className="card overflow-hidden border border-gray-100">
        <div className="p-4 bg-gray-50 font-bold text-gray-700 border-b border-gray-100 flex justify-between items-center">
          <span>Active Positions</span>
          <span className="text-xs text-gray-400">{positions.length} Total</span>
        </div>
        <div className="divide-y divide-gray-100">
          {positions.map((job) => (
            <div key={job.id} className="p-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:bg-gray-50/30 transition-colors group">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <h3 className="text-lg font-bold text-[#212529]">{job.title}</h3>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${job.status === 'Active' ? 'bg-green-50 text-green-600' : 'bg-gray-100 text-gray-500'}`}>{job.status}</span>
                </div>
                <p className="text-sm text-gray-500">{job.department} · {job.location} · {job.type}</p>
              </div>
              <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => editPosition(job)} className="p-2 text-[#11469A] hover:bg-blue-50 rounded-lg transition-colors">
                  <SafeIcon name="Edit2" size={18} />
                </button>
                <button onClick={() => deletePosition(job.id)} className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors">
                  <SafeIcon name="Trash2" size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Positions;